import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return !_vm.isMobile ? _c(VSimpleTable, {
    staticClass: "clickable",
    attrs: {
      "fixed-header": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_c(VIcon, {
          staticClass: "mr-2",
          attrs: {
            "color": _vm.color,
            "small": ""
          }
        }, [_vm._v("fal fa-arrows-v")])], 1), _c('th', {
          staticClass: "text-left"
        }, [_c(VIcon, {
          staticClass: "mr-2",
          attrs: {
            "color": _vm.color,
            "small": ""
          }
        }, [_vm._v("fal fa-clock")])], 1), _c('th', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.fc')))]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.payload')))]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.copy')))]), _c('th', {
          staticClass: "ext-left"
        }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.sf')))]), _vm.datasourceType == 'FIREFLY_MQTT' || _vm.datasourceType == 'TTN' ? _c('th', {
          staticClass: "text-left"
        }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.freq')) + "\n        ")]) : _vm._e(), _c('th', {
          staticClass: "text-left"
        }, [_c(VIcon, {
          staticClass: "mr-2",
          attrs: {
            "color": _vm.color,
            "small": ""
          }
        }, [_vm._v("fal fa-wifi")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.rssi')) + "\n        ")], 1), _c('th', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.lsnr')))]), _vm.datasourceType == 'FIREFLY_MQTT' || _vm.datasourceType == 'TTN' ? _c('th', {
          staticClass: "text-left"
        }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.bandwith')) + "\n        ")]) : _vm._e(), _vm.datasourceType == 'SIGFOX' || _vm.datasourceType == 'UDP' ? _c('th', {
          staticClass: "text-left"
        }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.station')) + "\n        ")]) : _vm._e()])]), _c('tbody', [_vm._l(_vm.packets, function (item, index) {
          return [_c('tr', {
            key: index
          }, [_c('td', {
            on: {
              "click": function ($event) {
                return _vm.clickedUserTableRow(item);
              }
            }
          }, [item.source_data.parsed_packet && item.source_data.parsed_packet.dir === 'up' ? _c(VIcon, {
            staticClass: "mr-2",
            attrs: {
              "color": _vm.color,
              "small": ""
            }
          }, [_vm._v("\n              fal fa-arrow-up\n            ")]) : _vm._e(), item.source_data.parsed_packet && item.source_data.parsed_packet.dir === 'down' ? _c(VIcon, {
            staticClass: "mr-2",
            attrs: {
              "color": _vm.color,
              "small": ""
            }
          }, [_vm._v("\n              fal fa-arrow-down\n            ")]) : _vm._e()], 1), _c('td', {
            on: {
              "click": function ($event) {
                return _vm.clickedUserTableRow(item);
              }
            }
          }, [!_vm.switchDate ? _c('span', [_vm._v("\n              " + _vm._s(item.ago) + "\n            ")]) : _c('span', [_vm._v("\n              " + _vm._s(_vm.localizeDate(item.source_time)) + "\n            ")])]), _c('td', {
            on: {
              "click": function ($event) {
                return _vm.clickedUserTableRow(item);
              }
            }
          }, [_vm.datasourceType == 'FIREFLY_MQTT' ? _c('span', [_vm._v("\n              " + _vm._s(item.source_data.frame_counter) + "\n            ")]) : _vm._e(), _vm.datasourceType == 'TTN' ? _c('span', [_vm._v("\n              " + _vm._s(item.source_data.counter) + "\n            ")]) : _vm._e(), _vm.datasourceType == 'ACTILITY' ? _c('span', [_vm._v("\n              " + _vm._s(item.source_data.FCntUp) + "\n            ")]) : _vm._e(), _vm.datasourceType == 'SIGFOX' || _vm.datasourceType == 'UDP' ? _c('span', [_vm._v("\n              " + _vm._s(item.source_data.seqNumber) + "\n            ")]) : _vm._e()]), _c('td', {
            on: {
              "click": function ($event) {
                return _vm.clickedUserTableRow(item);
              }
            }
          }, [_c('span', {
            staticClass: "euiElement preformatted__text"
          }, [_vm._v("\n              " + _vm._s(item.payload) + "\n            ")])]), _c('td', [_vm.isCopySupported() ? _c('div', {
            staticClass: "payloadElement",
            on: {
              "click": function ($event) {
                return _vm.copyToClipboard($event, item.payload);
              }
            }
          }, [_c(VIcon, {
            staticClass: "pointer",
            attrs: {
              "small": ""
            }
          }, [_vm._v("fal fa-copy")])], 1) : _vm._e()]), _c('td', {
            on: {
              "click": function ($event) {
                return _vm.clickedUserTableRow(item);
              }
            }
          }, [_vm.datasourceType == 'FIREFLY_MQTT' ? _c('span', [_vm._v("\n              " + _vm._s(item.source_data.spreading_factor) + "\n            ")]) : _vm._e(), _vm.datasourceType == 'TTN' ? _c('span', [item.source_data.metadata.data_rate.split('BW')[0].length == 4 ? _c('span', [_vm._v("\n                " + _vm._s(item.source_data.metadata.data_rate.split('BW')[0].substr(-2)) + "\n              ")]) : _vm._e(), item.source_data.metadata.data_rate.split('BW')[0].length == 3 ? _c('span', [_vm._v("\n                " + _vm._s(item.source_data.metadata.data_rate.split('BW')[0].substr(-1)) + "\n              ")]) : _vm._e()]) : _vm._e(), _vm.datasourceType == 'ACTILITY' ? _c('span', [_vm._v("\n              " + _vm._s(item.source_data.SpFact) + "\n            ")]) : _vm._e()]), _vm.datasourceType == 'FIREFLY_MQTT' || _vm.datasourceType == 'TTN' ? _c('td', {
            on: {
              "click": function ($event) {
                return _vm.clickedUserTableRow(item);
              }
            }
          }, [_vm.datasourceType == 'FIREFLY_MQTT' ? _c('span', [_vm._v("\n              " + _vm._s(_vm.get(item, 'source_data.server_data.freq')) + "\n            ")]) : _vm._e(), _vm.datasourceType == 'TTN' && item.source_data ? _c('span', [_vm._v("\n              " + _vm._s(_vm.get(item, 'source_data.metadata.frequency')) + "\n            ")]) : _vm._e()]) : _vm._e(), _c('td', {
            on: {
              "click": function ($event) {
                return _vm.clickedUserTableRow(item);
              }
            }
          }, [_vm.datasourceType == 'FIREFLY_MQTT' ? _c('span', [_vm._v("\n              " + _vm._s(_vm.get(item, 'source_data.server_data.gwrx[0].rssi')) + "\n            ")]) : _vm._e(), _vm.datasourceType == 'TTN' ? _c('span', [_vm._v("\n              " + _vm._s(_vm.get(item, 'source_data.metadata.gateways[0].rssi')) + "\n            ")]) : _vm._e(), _vm.datasourceType == 'ACTILITY' ? _c('span', [_vm._v("\n              " + _vm._s(_vm.get(item, 'source_data.Lrrs.Lrr[0].LrrRSSI')) + "\n            ")]) : _vm._e(), _vm.datasourceType == 'SIGFOX' || _vm.datasourceType == 'UDP' ? _c('span', [_vm._v("\n              " + _vm._s(item.source_data.rssi) + "\n            ")]) : _vm._e()]), _c('td', {
            on: {
              "click": function ($event) {
                return _vm.clickedUserTableRow(item);
              }
            }
          }, [_vm.datasourceType == 'FIREFLY_MQTT' ? _c('span', [_vm._v("\n              " + _vm._s(_vm.get(item, 'source_data.server_data.gwrx[0].lsnr')) + "\n            ")]) : _vm._e(), _vm.datasourceType == 'TTN' ? _c('span', [_vm._v("\n              " + _vm._s(_vm.get(item, 'source_data.metadata.gateways[0].snr')) + "\n            ")]) : _vm._e(), _vm.datasourceType == 'ACTILITY' ? _c('span', [_vm._v("\n              " + _vm._s(_vm.get(item, 'source_data.Lrrs.Lrr[0].LrrSNR')) + "\n            ")]) : _vm._e(), _vm.datasourceType == 'SIGFOX' || _vm.datasourceType == 'UDP' ? _c('span', [_vm._v("\n              " + _vm._s(_vm.get(item, 'source_data.snr')) + "\n            ")]) : _vm._e()]), _vm.datasourceType == 'FIREFLY_MQTT' || _vm.datasourceType == 'TTN' ? _c('td', {
            on: {
              "click": function ($event) {
                return _vm.clickedUserTableRow(item);
              }
            }
          }, [_vm.datasourceType == 'FIREFLY_MQTT' ? _c('span', [_vm._v("\n              " + _vm._s(item.source_data.bandwidth) + "\n            ")]) : _vm._e(), _vm.datasourceType == 'TTN' ? _c('span', [_vm._v("\n              " + _vm._s(item.source_data.metadata.data_rate.split('BW')[1]) + "\n            ")]) : _vm._e()]) : _vm._e(), _vm.datasourceType == 'SIGFOX' || _vm.datasourceType == 'UDP' ? _c('td', {
            on: {
              "click": function ($event) {
                return _vm.clickedUserTableRow(item);
              }
            }
          }, [_vm._v("\n            " + _vm._s(item.source_data.station) + "\n          ")]) : _vm._e()]), _vm.opened.includes(item.uid) ? _c('tr', {
            key: index + 100,
            staticClass: "expanded"
          }, [_c('td', {
            attrs: {
              "colspan": "11"
            }
          }, [_c(VRow, [_c(VCol, {
            attrs: {
              "cols": "12",
              "md": "4"
            }
          }, [_c('div', {
            staticClass: "detailfield"
          }, [item.source_data.parsed_packet && item.source_data.parsed_packet.dir === 'up' ? _c('p', {
            staticClass: "fbold"
          }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.upPacket')) + "\n                  ")]) : _vm._e(), item.source_data.parsed_packet && item.source_data.parsed_packet.dir === 'down' ? _c('p', {
            staticClass: "fbold"
          }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.downPacket')) + "\n                  ")]) : _vm._e()])]), _c(VCol, {
            attrs: {
              "cols": "12",
              "md": "8"
            }
          }, [_c('div', {
            staticClass: "detailfield"
          }, [_c('span', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.rawPayload')))])]), _c('div', {
            staticClass: "detailvalue"
          }, [_vm.datasourceType == 'FIREFLY_MQTT' ? _c('span', {
            staticClass: "euiElement",
            staticStyle: {
              "text-overflow": "ellipsis",
              "overflow": "hidden",
              "white-space": "nowrap",
              "max-width": "397px"
            }
          }, [_c('pre', [_vm._v(_vm._s(item.source_data.raw_payload))])]) : _vm._e(), _vm.datasourceType == 'FIREFLY_MQTT' ? _c('span', {
            staticClass: "copy-icon-payload",
            on: {
              "click": function ($event) {
                return _vm.copyToClipboard($event, item.source_data.raw_payload);
              }
            }
          }, [_c(VIcon, {
            staticClass: "pointer",
            attrs: {
              "small": ""
            }
          }, [_vm._v("fal fa-copy")])], 1) : _vm._e(), _vm.datasourceType == 'TTN' ? _c('span', {
            staticClass: "euiElement"
          }, [_c('pre', [_vm._v(_vm._s(item.source_data.payload_raw))])]) : _vm._e(), _vm.datasourceType == 'TTN' ? _c('span', {
            staticClass: "copy-icon-payload",
            on: {
              "click": function ($event) {
                return _vm.copyToClipboard($event, item.source_data.payload_raw);
              }
            }
          }, [_c(VIcon, {
            staticClass: "pointer",
            attrs: {
              "small": ""
            }
          }, [_vm._v("fal fa-copy")])], 1) : _vm._e(), _vm.datasourceType == 'ACTILITY' ? _c('span', {
            staticClass: "euiElement"
          }, [_c('pre', [_vm._v(_vm._s(item.payload))])]) : _vm._e(), _vm.datasourceType == 'ACTILITY' ? _c('span', {
            staticClass: "copy-icon-payload",
            on: {
              "click": function ($event) {
                return _vm.copyToClipboard($event, item.payload);
              }
            }
          }, [_c(VIcon, {
            staticClass: "pointer",
            attrs: {
              "small": ""
            }
          }, [_vm._v("fal fa-copy")])], 1) : _vm._e(), _vm.datasourceType == 'SIGFOX' && _vm.datasourceType == 'UDP' ? _c('span', {
            staticClass: "euiElement"
          }, [_c('pre', [_vm._v(_vm._s(item.payload))])]) : _vm._e(), _vm.datasourceType == 'SIGFOX' && _vm.datasourceType == 'UDP' ? _c('span', {
            staticClass: "copy-icon-payload",
            on: {
              "click": function ($event) {
                return _vm.copyToClipboard($event, item.payload);
              }
            }
          }, [_c(VIcon, {
            staticClass: "pointer",
            attrs: {
              "small": ""
            }
          }, [_vm._v("fal fa-copy")])], 1) : _vm._e()])]), _vm.datasourceType == 'FIREFLY_MQTT' && item.source_data.parsed && item.source_data.parsed.gps ? _c(VCol, {
            attrs: {
              "cols": "12",
              "md": "10"
            }
          }, [_c('div', {
            staticClass: "detailfield"
          }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.viewGoogleMap')) + "\n                ")]), _c('div', {
            staticClass: "detailvalue"
          }, [_c('a', {
            attrs: {
              "href": _vm.getLink(_vm.datasourceType, item),
              "target": "_blank"
            }
          }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.clickHere')) + "\n                  ")])])]) : _vm._e(), _vm.datasourceType == 'ACTILITY' && item.source_data.LrrLAT ? _c(VCol, {
            attrs: {
              "cols": "12",
              "md": "10"
            }
          }, [_c('div', {
            staticClass: "detailfield"
          }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.viewGoogleMap')) + "\n                ")]), _c('div', {
            staticClass: "detailvalue"
          }, [_c('a', {
            attrs: {
              "href": _vm.getLink(_vm.datasourceType, item),
              "target": "_blank"
            }
          }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.clickHere')) + "\n                  ")])])]) : _vm._e(), _c(VCol, {
            attrs: {
              "cols": "12",
              "md": "4"
            }
          }, [_c('div', {
            staticClass: "detailfield"
          }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.deviceAddress')) + "\n                ")]), _c('div', {
            staticClass: "detailvalue"
          }, [item.source_data.device && _vm.datasourceType != 'ACTILITY' ? _c('span', {
            staticClass: "euiElement"
          }, [_c('pre', [_vm._v(_vm._s(item.source_data.device.address))])]) : _vm._e(), item.source_data.device && _vm.datasourceType != 'ACTILITY' ? _c('span', {
            staticClass: "copy-icon",
            on: {
              "click": function ($event) {
                return _vm.copyToClipboard($event, item.source_data.device.address);
              }
            }
          }, [_c(VIcon, {
            staticClass: "pointer",
            attrs: {
              "small": ""
            }
          }, [_vm._v("fal fa-copy")])], 1) : _vm._e(), _vm.datasourceType == 'ACTILITY' ? _c('span', {
            staticClass: "euiElement"
          }, [_c('pre', [_vm._v(_vm._s(item.source_data.DevAddr))])]) : _vm._e(), _vm.datasourceType == 'ACTILITY' ? _c('span', {
            staticClass: "copy-icon",
            on: {
              "click": function ($event) {
                return _vm.copyToClipboard($event, item.source_data.DevAddr);
              }
            }
          }, [_c(VIcon, {
            staticClass: "pointer",
            attrs: {
              "small": ""
            }
          }, [_vm._v("fal fa-copy")])], 1) : _vm._e()])]), _c(VCol, {
            attrs: {
              "cols": "12",
              "md": "6"
            }
          }, [_c('div', {
            staticClass: "detailfield"
          }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.deviceEui')) + "\n                ")]), _c('div', {
            staticClass: "detailvalue euiElement"
          }, [_c('pre', [_vm._v(_vm._s(item.eui))])]), _c('span', {
            staticClass: "copy-icon",
            on: {
              "click": function ($event) {
                return _vm.copyToClipboard($event, item.eui);
              }
            }
          }, [_c(VIcon, {
            staticClass: "pointer",
            attrs: {
              "small": ""
            }
          }, [_vm._v("fal fa-copy")])], 1)]), _c(VCol, {
            attrs: {
              "cols": "12",
              "md": "4"
            }
          }, [_c('div', {
            staticClass: "detailfield"
          }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.getCompleteJson')) + "\n                  "), _c('span', {
            on: {
              "click": function ($event) {
                return _vm.copyToClipboard($event, item);
              }
            }
          }, [_c(VIcon, {
            staticClass: "pointer",
            attrs: {
              "small": ""
            }
          }, [_vm._v("fal fa-copy")])], 1)])]), _c(VCol, {
            attrs: {
              "cols": "12",
              "md": "6"
            }
          }, [_c('div', {
            staticClass: "detailfield"
          }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Common.createdAt')) + "\n                ")]), _c('div', {
            staticClass: "detailvalue"
          }, [_c('span', [_vm._v(_vm._s(_vm.localizeDate(item.source_time)))])])]), _c(VCol, {
            attrs: {
              "cols": "12",
              "md": "12"
            }
          }, [_c('div', {
            staticClass: "detailfield"
          }, [_vm.datasourceType != 'ACTILITY' ? _c('p', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: item.source_data.parsed_packet && item.source_data.parsed_packet.dir === 'up',
              expression: "item.source_data.parsed_packet && item.source_data.parsed_packet.dir === 'up'"
            }]
          }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.gws')) + "\n                  ")]) : _vm._e(), _vm.datasourceType == 'ACTILITY' ? _c('p', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.gws')))]) : _vm._e()])]), _c(VCol, {
            attrs: {
              "cols": "12",
              "md": "12"
            }
          }, [_c('div', {
            staticClass: "gwlist"
          }, [_vm.datasourceType == 'FIREFLY_MQTT' && _vm.get(item, 'source_data.server_data.gwrx') && _vm.get(item, 'source_data.server_data.gwrx').length ? _c(VSimpleTable, {
            scopedSlots: _vm._u([{
              key: "default",
              fn: function () {
                return [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.gatewayID')))]), _c('th', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.deviceDetails')))]), _c('th', [_c(VIcon, {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("fal fa-wifi")]), _vm._v("\n                            " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.rssi')) + "\n                          ")], 1), _c('th', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.lsnr')))])])]), _vm._l(_vm.get(item, 'source_data.server_data.gwrx'), function (gw, i) {
                  return _c('tbody', {
                    key: i
                  }, [_c('tr', [_c('td', [_c('span', [_vm._v(_vm._s(gw.gweui))])]), _c('td', [_c('a', {
                    attrs: {
                      "href": _vm.gmsLink(gw.gweui),
                      "target": "_blank"
                    }
                  }, [_c(VIcon, {
                    attrs: {
                      "small": ""
                    }
                  }, [_vm._v("fal fa-eye")])], 1)]), _c('td', [_vm._v(_vm._s(gw.rssi))]), _c('td', [_vm._v(_vm._s(gw.lsnr))])])]);
                })];
              },
              proxy: true
            }], null, true)
          }) : _vm._e(), _vm.datasourceType == 'TTN' && item.source_data.metadata.gateways.length ? _c(VSimpleTable, {
            scopedSlots: _vm._u([{
              key: "default",
              fn: function () {
                return [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.gatewayID')))]), _c('th', [_c(VIcon, {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("fal fa-wifi")]), _vm._v("\n                            " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.rssi')) + "\n                          ")], 1), _c('th', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.lsnr')))])])]), _vm._l(item.source_data.metadata.gateways, function (gw, i) {
                  return _c('tbody', {
                    key: i
                  }, [_c('tr', [_c('td', [_vm._v(_vm._s(gw.gtw_id))]), _c('td', [_vm._v(_vm._s(gw.rssi))]), _c('td', [_vm._v(_vm._s(gw.lsnr))])])]);
                })];
              },
              proxy: true
            }], null, true)
          }) : _vm._e(), _vm.datasourceType == 'ACTILITY' && item.source_data && item.source_data.metadata && item.source_data.metadata.gateways ? _c('div', [item.source_data.Lrrs.Lrr.length ? _c(VSimpleTable, {
            scopedSlots: _vm._u([{
              key: "default",
              fn: function () {
                return [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.gatewayID')))]), _c('th', [_c(VIcon, {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("fal fa-wifi")]), _vm._v("\n                              " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.rssi')) + "\n                            ")], 1), _c('th', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.lsnr')))])])]), _vm._l(item.source_data.metadata.gateways, function (gw, i) {
                  return _c('tbody', {
                    key: i
                  }, [_c('tr', [_c('td', [_vm._v(_vm._s(gw.Lrrid))]), _c('td', [_vm._v(_vm._s(gw.LrrRSSI))]), _c('td', [_vm._v(_vm._s(gw.LrrSNR))])])]);
                })];
              },
              proxy: true
            }], null, true)
          }) : _vm._e()], 1) : _vm.datasourceType == 'ACTILITY' && item.signal ? _c('div', [_c(VSimpleTable, {
            scopedSlots: _vm._u([{
              key: "default",
              fn: function () {
                return [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.gatewayID')))]), _c('th', [_c(VIcon, {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("fal fa-wifi")]), _vm._v("\n                              " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.rssi')) + "\n                            ")], 1), _c('th', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.lsnr')))])])]), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(item.signal.gateway))]), _c('td', [_vm._v(_vm._s(item.signal.rssi))]), _c('td', [_vm._v(_vm._s(item.signal.snr))])])])];
              },
              proxy: true
            }], null, true)
          })], 1) : _vm._e()], 1)])], 1), _c(VRow, [item.parsed ? _c(VCol, {
            attrs: {
              "cols": "12",
              "md": "6",
              "xs": "12"
            }
          }, [_c('div', {
            staticClass: "detailfield"
          }, [_c('p', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: item.source_data.parsed_packet && item.source_data.parsed_packet.dir === 'up',
              expression: "item.source_data.parsed_packet && item.source_data.parsed_packet.dir === 'up'"
            }]
          }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.parsedPacketData')) + " (firefly)\n                  ")])]), _c('div', {
            staticClass: "detailvalue"
          }, [_c('pre', [_vm._v(_vm._s(item.source_data.parsed))])])]) : _vm._e(), _vm.datasourceType == 'FIREFLY_MQTT' || _vm.datasourceType == 'UDP' && (item.parsed || item.source_data.parsed) ? _c(VCol, {
            attrs: {
              "cols": "12",
              "md": "6",
              "xs": "12"
            }
          }, [_c('div', {
            staticClass: "detailfield"
          }, [_c('p', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: item.source_data.parsed_packet && item.source_data.parsed_packet.dir === 'up',
              expression: "item.source_data.parsed_packet && item.source_data.parsed_packet.dir === 'up'"
            }]
          }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.parsedPacketData')) + " (niota)\n                  ")])]), _c('div', {
            staticClass: "detailvalue"
          }, [_c('pre', [_vm._v(_vm._s(item.parsed))])])]) : _vm._e()], 1)], 1)]) : _vm._e()];
        })], 2)];
      },
      proxy: true
    }], null, false, 78292387)
  }) : _c(VSimpleTable, {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('tbody', [_vm._l(_vm.packets, function (item, index) {
          return [_c('tr', {
            key: index
          }, [_c('td', {
            on: {
              "click": function ($event) {
                return _vm.clickedUserTableRow(item);
              }
            }
          }, [_c('ul', {
            staticClass: "flex-content"
          }, [_c('li', {
            staticClass: "flex-item"
          }, [item.source_data.parsed_packet && item.source_data.parsed_packet.dir === 'up' ? _c(VIcon, {
            staticClass: "mr-2",
            attrs: {
              "color": _vm.color
            }
          }, [_vm._v("\n                  fal fa-arrow-up\n                ")]) : _vm._e(), item.source_data.parsed_packet && item.source_data.parsed_packet.dir === 'down' ? _c(VIcon, {
            staticClass: "mr-2",
            attrs: {
              "color": _vm.color
            }
          }, [_vm._v("\n                  fal fa-arrow-down\n                ")]) : _vm._e()], 1), _c('li', {
            staticClass: "flex-item"
          }, [_vm._v(_vm._s(item.ago))]), _c('li', {
            staticClass: "flex-item"
          }, [_c('span', {
            staticClass: "label"
          }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.fc')))]), _c('br'), _vm.datasourceType == 'FIREFLY_MQTT' ? _c('span', [_vm._v("\n                  " + _vm._s(item.source_data.frame_counter) + "\n                ")]) : _vm._e(), _vm.datasourceType == 'TTN' ? _c('span', [_vm._v("\n                  " + _vm._s(item.source_data.counter) + "\n                ")]) : _vm._e(), _vm.datasourceType == 'ACTILITY' ? _c('span', [_vm._v("\n                  " + _vm._s(item.source_data.FCntUp) + "\n                ")]) : _vm._e(), _vm.datasourceType == 'SIGFOX' || _vm.datasourceType == 'UDP' ? _c('span', [_vm._v("\n                  " + _vm._s(item.source_data.seqNumber) + "\n                ")]) : _vm._e()]), _c('li', {
            staticClass: "flex-item"
          }, [_c('span', {
            staticClass: "label"
          }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.payload')))]), _c('br'), _c('span', {
            staticClass: "euiElement",
            staticStyle: {
              "text-overflow": "ellipsis",
              "overflow": "hidden",
              "white-space": "nowrap",
              "max-width": "138px"
            }
          }, [_c('pre', [_vm._v(_vm._s(item.payload))])])]), _c('li', {
            staticClass: "flex-item"
          }, [_c('span', {
            staticClass: "label"
          }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.sf')))]), _c('br'), _vm.datasourceType == 'FIREFLY_MQTT' ? _c('span', [_vm._v("\n                  " + _vm._s(item.source_data.spreading_factor) + "\n                ")]) : _vm._e(), _vm.datasourceType == 'TTN' ? _c('span', [item.source_data.metadata.data_rate.split('BW')[0].length == 4 ? _c('span', [_vm._v("\n                    " + _vm._s(item.source_data.metadata.data_rate.split('BW')[0].substr(-2)) + "\n                  ")]) : _vm._e(), item.source_data.metadata.data_rate.split('BW')[0].length == 3 ? _c('span', [_vm._v("\n                    " + _vm._s(item.source_data.metadata.data_rate.split('BW')[0].substr(-1)) + "\n                  ")]) : _vm._e()]) : _vm._e(), _vm.datasourceType == 'ACTILITY' ? _c('span', [_vm._v("\n                  " + _vm._s(item.source_data.SpFact) + "\n                ")]) : _vm._e()]), _vm.datasourceType == 'FIREFLY_MQTT' || _vm.datasourceType == 'TTN' ? _c('li', {
            staticClass: "flex-item"
          }, [_c('span', {
            staticClass: "label"
          }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.freq')))]), _c('br'), _vm.datasourceType == 'FIREFLY_MQTT' ? _c('span', [_vm._v("\n                  " + _vm._s(_vm.get(item, 'source_data.server_data.freq')) + "\n                ")]) : _vm._e(), _vm.datasourceType == 'TTN' ? _c('span', [_vm._v("\n                  " + _vm._s(item.source_data.metadata.frequency) + "\n                ")]) : _vm._e()]) : _vm._e(), _c('li', {
            staticClass: "flex-item"
          }, [_c('span', {
            staticClass: "label"
          }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.rssi')))]), _c('br'), _vm.datasourceType == 'FIREFLY_MQTT' ? _c('span', [_vm._v("\n                  " + _vm._s(_vm.get(item, 'source_data.server_data.gwrx[0].rssi')) + "\n                ")]) : _vm._e(), _vm.datasourceType == 'TTN' ? _c('span', [_vm._v("\n                  " + _vm._s(item.source_data.metadata.gateways[0].rssi) + "\n                ")]) : _vm._e(), _vm.datasourceType == 'ACTILITY' ? _c('span', [_vm._v("\n                  " + _vm._s(item.source_data.Lrrs.Lrr[0].LrrRSSI) + "\n                ")]) : _vm._e(), _vm.datasourceType == 'SIGFOX' || _vm.datasourceType == 'UDP' ? _c('span', [_vm._v("\n                  " + _vm._s(item.source_data.rssi) + "\n                ")]) : _vm._e()]), _c('li', {
            staticClass: "flex-item"
          }, [_c('span', {
            staticClass: "label"
          }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.lsnr')))]), _c('br'), _vm.datasourceType == 'FIREFLY_MQTT' ? _c('span', [_vm._v("\n                  " + _vm._s(_vm.get(item, 'source_data.server_data.gwrx[0].lsnr')) + "\n                ")]) : _vm._e(), _vm.datasourceType == 'TTN' ? _c('span', [_vm._v("\n                  " + _vm._s(item.source_data.metadata.gateways[0].snr) + "\n                ")]) : _vm._e(), _vm.datasourceType == 'ACTILITY' ? _c('span', [_vm._v("\n                  " + _vm._s(item.source_data.Lrrs.Lrr[0].LrrSNR) + "\n                ")]) : _vm._e(), _vm.datasourceType == 'SIGFOX' || _vm.datasourceType == 'UDP' ? _c('span', [_vm._v("\n                  " + _vm._s(item.source_data.snr) + "\n                ")]) : _vm._e()]), _vm.datasourceType == 'FIREFLY_MQTT' || _vm.datasourceType == 'TTN' ? _c('li', {
            staticClass: "flex-item"
          }, [_c('span', {
            staticClass: "label"
          }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.bandwith')))]), _c('br'), _vm.datasourceType == 'FIREFLY_MQTT' ? _c('span', [_vm._v("\n                  " + _vm._s(item.source_data.bandwidth) + "\n                ")]) : _vm._e(), _vm.datasourceType == 'TTN' ? _c('span', [_vm._v("\n                  " + _vm._s(item.source_data.metadata.data_rate.split('BW')[1]) + "\n                ")]) : _vm._e()]) : _vm._e(), _c('li', [_vm.datasourceType == 'SIGFOX' || _vm.datasourceType == 'UDP' ? _c('span', {
            staticClass: "label"
          }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.station')) + "\n                ")]) : _vm._e(), _c('br'), _vm._v("\n                " + _vm._s(item.source_data.station) + "\n              ")])])])]), _vm.opened.includes(item.uid) ? _c('tr', {
            key: index + 100,
            staticClass: "expanded"
          }, [_c('td', {
            attrs: {
              "colspan": "11"
            }
          }, [_c(VRow, [_c(VCol, {
            attrs: {
              "cols": "12",
              "md": "4",
              "sm": "12"
            }
          }, [_c('div', {
            staticClass: "detailfield"
          }, [item.source_data.parsed_packet && item.source_data.parsed_packet.dir === 'up' ? _c('p', {
            staticClass: "fbold"
          }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.upPacket')) + "\n                  ")]) : _vm._e(), item.source_data.parsed_packet && item.source_data.parsed_packet.dir === 'down' ? _c('p', {
            staticClass: "fbold"
          }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.downPacket')) + "\n                  ")]) : _vm._e()])]), _c(VCol, {
            attrs: {
              "cols": "12",
              "md": "8",
              "sm": "12"
            }
          }, [_c('div', {
            staticClass: "detailfield"
          }, [_c('span', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.rawPayload')))])]), _c('div', {
            staticClass: "detailvalue custom-width"
          }, [_vm.datasourceType == 'FIREFLY_MQTT' ? _c('span', {
            staticClass: "euiElement payload-ellipsis"
          }, [_c('pre', [_vm._v(_vm._s(item.source_data.raw_payload))])]) : _vm._e(), _vm.datasourceType == 'TTN' ? _c('span', {
            staticClass: "euiElement payload-ellipsis"
          }, [_c('pre', [_vm._v(_vm._s(item.source_data.payload_raw))])]) : _vm._e(), _vm.datasourceType == 'ACTILITY' ? _c('span', {
            staticClass: "euiElement payload-ellipsis"
          }, [_c('pre', [_vm._v(_vm._s(item.payload))])]) : _vm._e(), _vm.datasourceType == 'SIGFOX' && _vm.datasourceType == 'UDP' ? _c('span', {
            staticClass: "euiElement payload-ellipsis"
          }, [_c('pre', [_vm._v(_vm._s(item.payload))])]) : _vm._e()]), _c('span', {
            staticStyle: {
              "position": "relative",
              "left": "5px"
            },
            on: {
              "click": function ($event) {
                return _vm.copyToClipboard($event, item.payload);
              }
            }
          }, [_c(VIcon, {
            staticClass: "pointer",
            attrs: {
              "small": ""
            }
          }, [_vm._v("fal fa-copy")])], 1)]), _vm.datasourceType == 'FIREFLY_MQTT' && item.source_data.parsed && item.source_data.parsed.gps ? _c(VCol, {
            attrs: {
              "cols": "12",
              "md": "10"
            }
          }, [_c('div', {
            staticClass: "detailfield"
          }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.viewGoogleMap')) + "\n                ")]), _c('div', {
            staticClass: "detailvalue"
          }, [_c('a', {
            attrs: {
              "href": _vm.getLink(_vm.datasourceType, item),
              "target": "_blank"
            }
          }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.clickHere')) + "\n                  ")])])]) : _vm._e(), _vm.datasourceType == 'ACTILITY' && item.source_data.LrrLAT ? _c(VCol, {
            attrs: {
              "cols": "12",
              "md": "10"
            }
          }, [_c('div', {
            staticClass: "detailfield"
          }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.viewGoogleMap')) + "\n                ")]), _c('div', {
            staticClass: "detailvalue"
          }, [_c('a', {
            attrs: {
              "href": _vm.getLink(_vm.datasourceType, item),
              "target": "_blank"
            }
          }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.clickHere')) + "\n                  ")])])]) : _vm._e(), _c(VCol, {
            attrs: {
              "cols": "12",
              "md": "4"
            }
          }, [_c('div', {
            staticClass: "detailfield"
          }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.deviceAddress')) + "\n                ")]), _c('div', {
            staticClass: "detailvalue"
          }, [item.source_data.device && _vm.datasourceType != 'ACTILITY' ? _c('span', {
            staticClass: "euiElement"
          }, [_c('pre', [_vm._v(_vm._s(item.source_data.device.address))])]) : _vm._e(), item.source_data.device && _vm.datasourceType != 'ACTILITY' ? _c('span', {
            staticClass: "copy-icon",
            on: {
              "click": function ($event) {
                return _vm.copyToClipboard($event, item.source_data.device.address);
              }
            }
          }, [_c(VIcon, {
            staticClass: "pointer",
            attrs: {
              "small": ""
            }
          }, [_vm._v("fal fa-copy")])], 1) : _vm._e(), _vm.datasourceType == 'ACTILITY' ? _c('span', {
            staticClass: "euiElement"
          }, [_c('pre', [_vm._v(_vm._s(item.source_data.DevAddr))])]) : _vm._e(), _vm.datasourceType == 'ACTILITY' ? _c('span', {
            staticClass: "copy-icon",
            on: {
              "click": function ($event) {
                return _vm.copyToClipboard($event, item.source_data.DevAddr);
              }
            }
          }, [_c(VIcon, {
            staticClass: "pointer",
            attrs: {
              "small": ""
            }
          }, [_vm._v("fal fa-copy")])], 1) : _vm._e()])]), _c(VCol, {
            attrs: {
              "cols": "12",
              "md": "6"
            }
          }, [_c('div', {
            staticClass: "detailfield"
          }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.deviceEui')) + "\n                ")]), _c('div', {
            staticClass: "detailvalue"
          }, [_c('span', {
            staticClass: "euiElement"
          }, [_c('pre', [_vm._v(_vm._s(item.eui))])]), _c('span', {
            staticClass: "copy-icon",
            on: {
              "click": function ($event) {
                return _vm.copyToClipboard($event, item.eui);
              }
            }
          }, [_c(VIcon, {
            staticClass: "pointer",
            attrs: {
              "small": ""
            }
          }, [_vm._v("fal fa-copy")])], 1)])]), _c(VCol, {
            attrs: {
              "cols": "12",
              "md": "4"
            }
          }, [_c('div', {
            staticClass: "detailfield"
          }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.getCompleteJson')) + "\n                  "), _c('span', {
            on: {
              "click": function ($event) {
                return _vm.copyToClipboard($event, item);
              }
            }
          }, [_c(VIcon, {
            staticClass: "pointer",
            attrs: {
              "small": ""
            }
          }, [_vm._v("fal fa-copy")])], 1)])]), _c(VCol, {
            attrs: {
              "cols": "12",
              "md": "6"
            }
          }, [_c('div', {
            staticClass: "detailfield"
          }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Common.createdAt')) + "\n                ")]), _c('div', {
            staticClass: "detailvalue"
          }, [_c('span', [_vm._v(_vm._s(_vm.localizeDate(item.source_time)))])])]), _c(VCol, {
            attrs: {
              "cols": "12",
              "md": "12"
            }
          }, [_c('div', {
            staticClass: "detailfield"
          }, [_vm.datasourceType != 'ACTILITY' ? _c('p', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: item.source_data.parsed_packet && item.source_data.parsed_packet.dir === 'up',
              expression: "item.source_data.parsed_packet && item.source_data.parsed_packet.dir === 'up'"
            }]
          }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.gws')) + "\n                  ")]) : _vm._e(), _vm.datasourceType == 'ACTILITY' ? _c('p', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.gws')))]) : _vm._e()])]), _c(VCol, {
            attrs: {
              "cols": "12",
              "md": "12"
            }
          }, [_c('div', {
            staticClass: "gwlist"
          }, [_vm.datasourceType == 'FIREFLY_MQTT' && _vm.get(item, 'source_data.server_data.gwrx') && _vm.get(item, 'source_data.server_data.gwrx').length ? _c(VSimpleTable, {
            scopedSlots: _vm._u([{
              key: "default",
              fn: function () {
                return [_c('tbody', [_vm._l(_vm.get(item, 'source_data.server_data.gwrx'), function (gw, i) {
                  return [_c('tr', {
                    key: i
                  }, [_c('td', [_c('ul', {
                    staticClass: "flex-content"
                  }, [_c('li', {
                    staticClass: "flex-item"
                  }, [_c('span', {
                    staticClass: "label"
                  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.gatewayID')))]), _c('br'), _vm._v("\n                                  " + _vm._s(gw.gweui) + "\n                                ")]), _c('li', {
                    staticClass: "flex-item"
                  }, [_c('span', {
                    staticClass: "label"
                  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.deviceDetails')))]), _c('br'), _c('a', {
                    attrs: {
                      "href": _vm.gmsLink(gw.gweui),
                      "target": "_blank"
                    }
                  }, [_c(VIcon, {
                    attrs: {
                      "small": ""
                    }
                  }, [_vm._v("fal fa-eye")])], 1)]), _c('li', {
                    staticClass: "flex-item"
                  }, [_c('span', {
                    staticClass: "label"
                  }, [_c(VIcon, {
                    attrs: {
                      "small": ""
                    }
                  }, [_vm._v("fal fa-wifi")]), _vm._v("\n                                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.rssi')) + "\n                                  ")], 1), _c('br'), _vm._v("\n                                  " + _vm._s(gw.rssi) + "\n                                ")]), _c('li', {
                    staticClass: "flex-item"
                  }, [_c('span', {
                    staticClass: "label"
                  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.lsnr')))]), _c('br'), _vm._v("\n                                  " + _vm._s(gw.lsnr) + "\n                                ")])])])])];
                })], 2)];
              },
              proxy: true
            }], null, true)
          }) : _vm._e(), _vm.datasourceType == 'TTN' && item.source_data.metadata.gateways.length ? _c(VSimpleTable, {
            scopedSlots: _vm._u([{
              key: "default",
              fn: function () {
                return [_c('tbody', [_vm._l(item.source_data.metadata.gateways, function (gw, i) {
                  return [_c('tr', {
                    key: i
                  }, [_c('td', [_c('ul', {
                    staticClass: "flex-content"
                  }, [_c('li', {
                    staticClass: "flex-item"
                  }, [_c('span', {
                    staticClass: "label"
                  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.gatewayID')))]), _c('br'), _vm._v("\n                                  " + _vm._s(gw.gtw_id) + "\n                                ")]), _c('li', {
                    staticClass: "flex-item"
                  }, [_c('span', {
                    staticClass: "label"
                  }, [_c(VIcon, {
                    attrs: {
                      "small": ""
                    }
                  }, [_vm._v("fal fa-wifi")]), _vm._v("\n                                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.rssi')) + "\n                                  ")], 1), _c('br'), _vm._v("\n                                  " + _vm._s(gw.rssi) + "\n                                ")]), _c('li', {
                    staticClass: "flex-item"
                  }, [_c('span', {
                    staticClass: "label"
                  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.lsnr')))]), _c('br'), _vm._v("\n                                  " + _vm._s(gw.lsnr) + "\n                                ")])])])])];
                })], 2)];
              },
              proxy: true
            }], null, true)
          }) : _vm._e(), _vm.datasourceType == 'ACTILITY' && item.source_data.Lrrs.Lrr.length ? _c(VSimpleTable, [_c('tbody', [_vm._l(item.source_data.metadata.gateways, function (gw, i) {
            return [_c('tr', {
              key: i
            }, [_c('td', [_c('ul', {
              staticClass: "flex-content"
            }, [_c('li', {
              staticClass: "flex-item"
            }, [_c('span', {
              staticClass: "label"
            }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.gatewayID')))]), _c('br'), _vm._v("\n                                " + _vm._s(gw.Lrrid) + "\n                              ")]), _c('li', {
              staticClass: "flex-item"
            }, [_c('span', {
              staticClass: "label"
            }, [_c(VIcon, {
              attrs: {
                "small": ""
              }
            }, [_vm._v("fal fa-wifi")]), _vm._v("\n                                  " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.rssi')) + "\n                                ")], 1), _c('br'), _vm._v("\n                                " + _vm._s(gw.LrrRSSI) + "\n                              ")]), _c('li', {
              staticClass: "flex-item"
            }, [_c('span', {
              staticClass: "label"
            }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.lsnr')))]), _c('br'), _vm._v("\n                                " + _vm._s(gw.LrrSNR) + "\n                              ")])])])])];
          })], 2)]) : _vm._e()], 1)])], 1), _c(VRow, [item.parsed ? _c(VCol, {
            attrs: {
              "cols": "12",
              "md": "6",
              "xs": "12"
            }
          }, [_c('div', {
            staticClass: "detailfield"
          }, [_c('p', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: item.source_data.parsed_packet && item.source_data.parsed_packet.dir === 'up',
              expression: "item.source_data.parsed_packet && item.source_data.parsed_packet.dir === 'up'"
            }]
          }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.parsedPacketData')) + " (firefly)\n                  ")])]), _c('div', {
            staticClass: "detailvalue"
          }, [_c('pre', [_vm._v(_vm._s(item.source_data.parsed))])])]) : _vm._e(), _vm.datasourceType == 'FIREFLY_MQTT' || _vm.datasourceType == 'UDP' && (item.parsed || item.source_data.parsed) ? _c(VCol, {
            attrs: {
              "cols": "12",
              "md": "6",
              "xs": "12"
            }
          }, [_c('div', {
            staticClass: "detailfield"
          }, [_c('p', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: item.source_data.parsed_packet && item.source_data.parsed_packet.dir === 'up',
              expression: "item.source_data.parsed_packet && item.source_data.parsed_packet.dir === 'up'"
            }]
          }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.parsedPacketData')) + " (niota)\n                  ")])]), _c('div', {
            staticClass: "detailvalue"
          }, [_c('pre', [_vm._v(_vm._s(item.parsed))])])]) : _vm._e()], 1)], 1)]) : _vm._e()];
        })], 2)];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };